<template>
    <div id="cfsBatchUpdate">
        <a-modal v-model="visible" :title="labelName" :maskClosable="false"  >
            <template slot="footer">
                <a-button size="small" type="primary" @click="save">Save</a-button>
            </template>
            <a-form :form="form" >
                <a-form-item :label="$t('arrivedTime')"  v-bind="formItemLayout">
                    <a-date-picker
                            :placeholder="$t('publicLang.PleaseSelect')"
                            format="YYYY-MM-DD HH:mm"
                            size="small"
                            show-time
                            v-model="inputArrivedTime"
                            :disabled-date="disabledArrivedDate"/>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import moment from "moment";
    export default{
        data(){
            return{
                labelName: '',
                inputArrivedTime:'',
                visible: false,
                form:this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
            }
        },
        methods:{
            show(name,type,uids){
                this.uids = uids
                this.labelName = name
                this.visible = true
                this.ajaxtype = type
            },
            save(){
                let params = {
                    "uids": this.uids,
                    "arrivedTime": this.inputArrivedTime,
                }
                ajax.post(api.CFSSAVEARRIVEDATFACILITY,params).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg)
                        this.visible = false
                    }else{
                        this.$customMessage.warning(res.msg)
                    }
                })


            },
            disabledArrivedDate(current) {
                return current < moment().startOf('minute');//精确到分钟不可选
            },
        }
    }
</script>